import React from "react";
import { Context } from "../context";
import { Link } from "gatsby";
const BreadCrumb = ({ infos }) => {
    const { postType, //may be one of: index, post, archive, category, or anything else
    title, category, path, parents } = infos;
    const context = React.useContext(Context);
    const archive = context.archivePage;
    archive.uri = "/" + archive.slug + "/";
    let crumbs = [];
    crumbs.push({ tag: "a", uri: "/", title: "Accueil" });
    switch (postType) {
        case "archive":
            crumbs.push({ tag: "span", uri: archive.uri, title: archive.title });
            break;
        case "category":
            crumbs.push({ tag: "a", uri: archive.uri, title: archive.title });
            if (typeof parents !== "undefined" && parents.length) {
                crumbs.push(...parents.map(parent => {
                    return {
                        tag: "a",
                        ...parent
                    };
                }));
            }
            crumbs.push({ tag: "span", uri: path.canonicalPath, title });
            break;
        case "post":
            crumbs.push({ tag: "a", uri: archive.uri, title: archive.title });
            if (typeof parents !== "undefined" && parents.length) {
                crumbs.push(...parents.map(parent => {
                    return {
                        tag: "a",
                        ...parent
                    };
                }));
            }
            crumbs.push({ tag: "span", uri: path, title });
            break;
        default:
            if (typeof parents !== "undefined" && parents.length) {
                crumbs.push(...parents.map(parent => {
                    return {
                        tag: "a",
                        ...parent
                    };
                }));
            }
            crumbs.push({ tag: "span", uri: path, title });
    }
    if (postType === "index") {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { id: "breadcrumbs" },
        React.createElement("ol", { role: "navigation", "aria-label": "Vous \u00EAtes ici : ", itemScope: "", itemType: "https://schema.org/BreadcrumbList" }, crumbs.map((e, i) => {
            return (React.createElement("li", { itemProp: "itemListElement", itemScope: "", itemType: "https://schema.org/ListItem", key: i },
                e.tag === "a" ? (React.createElement(Link, { itemScope: "", itemType: "https://schema.org/Thing", itemProp: "item", to: e.uri, itemID: e.uri },
                    React.createElement("span", { itemProp: "name" }, e.title))) : (React.createElement("span", { itemScope: "", itemType: "https://schema.org/Thing", itemProp: "item", itemID: e.uri },
                    React.createElement("span", { itemProp: "name" }, e.title))),
                React.createElement("meta", { itemProp: "position", content: i + 1 })));
        }))));
};
export default BreadCrumb;
